export const achievements = [
  {
    id: 1,
    title: 'SAUVC 2019',
    description: 'Secured 17th Position internationally',
    year: '2019',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 2,
    title: 'Research Paper at OCEANS 2021',
    description: 'Development of AUV for SAUVC During COVID-19',
    year: '2021',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 3,
    title: 'VAX 2022',
    description: 'One among Top 30 teams internationally',
    year: '2022',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 4,
    title: 'Research Paper at OCEANS 2022',
    description: 'Design and Performance Analysis of Bio- Inspired Remotely Operated Robot',
    year: '2022',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 5,
    title: 'Research Paper at 2022 IEEE OES AUV SYMPOSIUM',
    description: 'Mechanical Design, Analysis and Development of an AUV for SAUVC',
    year: '2022',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 6,
    title: 'MATE ROV 2022',
    description: 'Fabricated a ROV & got selected to represent INDIA in MATE 2022 in USA',
    year: '2022',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 7,
    title: 'SAUVC 2022',
    description: 'Participated in SAUVC during September 2022.',
    year: '2022',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 8,
    title: 'MATE ROV OCEANS EXPLORER CHALLENGE 2023',
    description: 'Fabricated a hybrid ROV-AUV Vehicle and got selected to represent INDIA in MATE 2023 Placed 3rd worldwide in Oceans Explorer Challenge',
    year: '2023',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 9,
    title: 'AQUA QUEST',
    description: 'Hosting a Nationwide ROV competition on Feb 2024',
    year: '2024',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 10,
    title: 'Research Paper at OCEANS 2022',
    description: 'Analysis of Underwater Coral Reef Health Using Neural Networks',
    year: '2022',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 11,
    title: 'Research Paper at OCEANS 2024',
    description: 'Optimisation of Visual SLAM for Underwater Robotics using OAK-D Smart Camera',
    year: '2024',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 12,
    title: 'SAUVC 2024',
    description: 'Making the vehicle completely autonomous. Implementing novel idea for grasping objects.',
    year: '2024',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 13,
    title: 'IIT BOMBAY 2025',
    description: 'Secured 1st place in the International AUV Challenge, organised by IIT Bombay',
    year: '2025',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 14,
    title: 'IIT MADRAS 2025',
    description: "Secured 2nd Place in AquaVision '2025 hosted by IIT Madras.",
    year: '2025',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 15,
    title: 'SAUVC 2025',
    description: 'Secured 5th place globally in the Singapore AUV Challenge 2025',
    year: '2025',
    club: 'AUV Society',
    logo: '/teams/nira/logo.jpg',
  },
  {
    id: 16,
    title: 'European Rover Challenge 2023 (Remote)',
    description: '6th place internationally',
    year: '2023',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 17,
    title: 'European Rover Challenge 2023 (Onsite)',
    description: '21st place internationally',
    year: '2023',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 18,
    title: 'International Rover Challenge 2024 (Onsite)',
    description: '21st place internationally',
    year: '2024',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 19,
    title: 'Australian Rover Challenge 2024 (Documentation)',
    description: '5th place internationally',
    year: '2024',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 20,
    title: 'Australian Rover Challenge 2024 (Onsite)',
    description: '12th place internationally',
    year: '2024',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 21,
    title: 'ISRO Robotics Challenge 2024 (Onsite)',
    description: '6th place internationally',
    year: '2024',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 22,
    title: 'International Rover Challenge 2025 (Onsite)',
    description: '16th place internationally',
    year: '2025',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 23,
    title: 'ERC 2023 (Remote) Proposal Round',
    description: '2nd place internationally',
    year: '2023',
    club: 'Mars Club',
    logo: '/teams/mars/logo.png',
  },
  {
    id: 24,
    title: 'IIT Bombay Competition 2024',
    description: 'Two teams in the top 50 out of 500, clearing the abstract round and flying RC planes with payload.',
    year: '2024',
    club: 'TAD',
    logo: '/teams/tad/logo.png',
  },
  {
    id: 25,
    title: 'IIT Madras – Boeing National Aeromodelling Competition 2024',
    description: 'Six teams cleared the abstract round, gaining experience in design thinking and teamwork.',
    year: '2024',
    club: 'TAD',
    logo: '/teams/tad/logo.png',
  },
  {
    id: 26,
    title: 'IAC-Conference 2024 by ASoI',
    description: 'Won Runner-up for designing a docking mechanism to charge electric-hybrid UAVs.',
    year: '2024',
    club: 'TAD',
    logo: '/teams/tad/logo.png',
  },
  {
    id: 27,
    title: 'SAE eBaja 2025 - Phase 1',
    description: 'Achieved All India Rank of 16 out of 86 teams, standing 4th in Tamil Nadu.',
    year: '2025',
    club: 'SAE Collegiate Club',
    logo: '/teams/revolt/logo.png',
  },
  {
    id: 28,
    title: 'SAE eBaja 2025 - Phase 2 (Virtuals)',
    description: 'Secured strong ranks: Design (25th), Cost (20th), Sustainability (7th), and IPG Event (5th).',
    year: '2025',
    club: 'SAE Collegiate Club',
    logo: '/teams/revolt/logo.png',
  },
  {
    id: 29,
    title: 'SAE eBaja 2025 - Overall',
    description: 'Finished with an overall All-India Rank of 35 out of 86 teams.',
    year: '2025',
    club: 'SAE Collegiate Club',
    logo: '/teams/revolt/logo.png',
  },
  {
    id: 30,
    title: 'SAE mBaja 2025 - Phase 1',
    description: 'Achieved an overall All India Rank of 9 and 2nd in Tamil Nadu.',
    year: '2025',
    club: 'SAE Collegiate Club',
    logo: '/teams/revolt/logo.png',
  },
  {
    id: 31,
    title: 'SAE mBaja 2025 - Phase 2',
    description: 'Secured top ranks in multiple categories: Design (AIR 7), Cost (AIR 7), and Sustainability (AIR 10).',
    year: '2025',
    club: 'SAE Collegiate Club',
    logo: '/teams/revolt/logo.png',
  },
  {
    id: 32,
    title: 'SAE mBaja 2025 - Phase 3 (Statics)',
    description: 'Achieved top final ranks in key static events: Design (AIR 7), Cost (AIR 5), and CAE (AIR 5).',
    year: '2025',
    club: 'SAE Collegiate Club',
    logo: '/teams/revolt/logo.png',
  },
  {
    id: 33,
    title: 'SAE mBaja 2025 - Overall',
    description: 'Secured an impressive overall All India Rank (AIR) of 18.',
    year: '2025',
    club: 'SAE Collegiate Club',
    logo: '/teams/revolt/logo.png',
  },
];

// Helper function to get achievements by club
export const getAchievementsByClub = (club) => {
  if (club === 'all') return achievements;
  return achievements.filter(achievement => achievement.club === club);
};

// Helper function to get achievements by year
export const getAchievementsByYear = (year) => {
  if (year === 'all') return achievements;
  return achievements.filter(achievement => achievement.year === year);
};

// Helper function to get unique years
export const getUniqueYears = () => {
  const years = new Set(achievements.map(a => a.year));
  return Array.from(years).sort((a, b) => b - a);
};

// Helper function to get unique clubs
export const getUniqueClubs = () => {
  const clubs = new Set(achievements.map(a => a.club));
  return Array.from(clubs).sort();
};
